import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ClearFilterIconButtonProps {
  onClick: () => void;
  visible?: boolean;
}

export const ClearFilterIconButton = ({
  onClick,
  visible = true,
}: ClearFilterIconButtonProps) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="p-0 w-6 h-6 bg-transparent hover:bg-transparent flex-shrink-0"
      title={t("common.clear")}
    >
      <X className="w-4 h-4" />
    </Button>
  );
};
